import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';
import { normalizeCopiedRepositoryMediaResponse } from './normalizeCopiedRepositoryMediaResponse';

export function mapCopiedRepositoryMediaToFiles(
  response: unknown,
): Array<Partial<TFileWithMeta> & { meta: Partial<TFileWithMeta['meta']> }> {
  const now = new Date().toISOString();

  return normalizeCopiedRepositoryMediaResponse(response).map((item) => {
    const mediaId = String(item.id ?? item.Id ?? '');
    const name = String(item.fileName ?? item.Name ?? '');

    return {
      meta: {
        id: mediaId,
        name,
        size: Number(item.fileSize ?? item.Size) || 0,
        status: 'external',
        percent: 100,
        uploadedAt: now,
        extra: {
          mediaId,
          duration: 0,
          analysisStatus: 'progress',
        },
      },
    };
  });
}
